<div class="ion-padding bm">
  <h2><ion-icon name="copy-outline"></ion-icon> Bizonyítványmásodlat</h2>
  <p class="bm-halvany">
    Elveszett vagy megsemmisült bizonyítvány helyett, illetve névváltozáskor. A másodlat az eredeti bizonyítvány tárolt
    adataiból készül (ugyanazzal a sablonnal), minden lapján „BIZONYÍTVÁNYMÁSODLAT” jelöléssel és a záradékkal; aláírva,
    időbélyeggel a dokumentumtárba kerül, iktatódik, és a tanuló törzslapjára bejegyzés készül (20/2012. EMMI r. 113. §).
    <b>Sima papírra nyomtatandó – engedélyezett, sorszámozott bizonyítványnyomtatványra nem.</b>
  </p>

  <ion-note color="danger" class="bm-hiba" *ngIf="hiba">{{ hiba }}</ion-note>

  <div class="bm-kartya">
    <h3>1. Tanuló</h3>
    <div class="bm-kereso">
      <input type="search" [(ngModel)]="kereses" (ngModelChange)="keresesValtozott()" placeholder="Név vagy oktatási azonosító…"
             aria-label="Tanuló keresése">
      <ion-spinner name="dots" *ngIf="keres"></ion-spinner>
    </div>
    <ul class="bm-talalatok" *ngIf="talalatok.length">
      <li *ngFor="let t of talalatok">
        <button type="button" (click)="valaszt(t)">{{ t.nev }} <span class="bm-halvany">{{ t.oktazon }}<span *ngIf="t.szul_datum">, szül.: {{ datum(t.szul_datum) }}</span></span></button>
      </li>
    </ul>
  </div>

  <ng-container *ngIf="adat">
    <div class="bm-kartya">
      <h3>2. Tanév – {{ adat.tanulo.nev }} ({{ adat.tanulo.oktazon }})</h3>
      <p class="bm-halvany" *ngIf="!adat.tanevek.length">Ennek a tanulónak nincs osztálya ebben az intézményben.</p>
      <label class="bm-radio" *ngFor="let t of adat.tanevek">
        <input type="radio" name="tanev" [value]="t.tanev + '|' + t.osztaly_id" [(ngModel)]="u.tanevKulcs" (ngModelChange)="tanevValtozott()">
        <span><b>{{ t.tanev_cimke }}</b> – {{ t.osztaly }} ({{ t.evfolyam }}. évfolyam)
          <span class="bm-halvany">
            <span *ngIf="t.digitalis"> · digitális bizonyítvány: <a [href]="fajlUrl(t.digitalis.path)" target="_blank" rel="noopener">{{ t.digitalis.nev }}</a></span>
            <span *ngFor="let p of t.papir"> · papír: {{ p.sorozat }} {{ p.sorszam }} ({{ p.allapot }})</span>
          </span>
        </span>
      </label>
      <div *ngIf="adat.masodlatok.length" class="bm-korabbi">
        <h4>Korábbi másodlatai</h4>
        <ul>
          <li *ngFor="let m of adat.masodlatok">
            {{ m.tanev }}/{{ m.tanev + 1 }} {{ m.osztaly_nev }} – {{ datum(m.kiadas_napja) }}, iktatószám: {{ m.iktatoszam }}
            <a *ngIf="m.path" [href]="fajlUrl(m.path)" target="_blank" rel="noopener">PDF</a>
          </li>
        </ul>
      </div>
    </div>

    <form class="bm-kartya bm-urlap" *ngIf="tanev" (ngSubmit)="kiallit()">
      <h3>3. A másodlat adatai</h3>
      <label>A kiadás oka *
        <select name="ok" [(ngModel)]="u.ok" required>
          <option value="" disabled>– válassz –</option>
          <option *ngFor="let o of adat.okok" [value]="o.kod">{{ o.nev }}</option>
        </select>
      </label>
      <label>Részletek{{ u.ok === 'egyeb' ? ' *' : '' }}
        <input type="text" name="ok_reszletek" [(ngModel)]="u.ok_reszletek" maxlength="300" placeholder="pl. a kérelem kelte, a bejelentés">
      </label>
      <label>Az eredeti bizonyítvány *
        <select name="sors" [(ngModel)]="u.eredeti_sorsa">
          <option *ngFor="let s of adat.sorsok" [value]="s.kod">{{ s.nev }}</option>
        </select>
      </label>
      <label>Az eredeti sorszáma
        <input type="text" name="eredeti_sorszam" [(ngModel)]="u.eredeti_sorszam" maxlength="60">
      </label>
      <label *ngIf="kiadottPapir.length" class="bm-pipa">
        <input type="checkbox" name="papir_bevonas" [checked]="!!u.papir_bevonas"
               (change)="u.papir_bevonas = $any($event.target).checked ? kiadottPapir[0].id : ''">
        Az eredeti papír bizonyítvány ({{ kiadottPapir[0].sorozat }} {{ kiadottPapir[0].sorszam }}) bevonása a szigorú számadásban
      </label>
      <label>A kiállító neve *
        <input type="text" name="kiallito_nev" [(ngModel)]="u.kiallito_nev" maxlength="150">
      </label>
      <label class="bm-szeles">A kiállító címe *
        <input type="text" name="kiallito_cim" [(ngModel)]="u.kiallito_cim" maxlength="300">
      </label>
      <label>A kiadás napja *
        <input type="date" name="kiadas_napja" [(ngModel)]="u.kiadas_napja">
      </label>
      <label *ngIf="!adat.iktatgato">A másodlat iktatószáma *
        <input type="text" name="iktatoszam" [(ngModel)]="u.iktatoszam" maxlength="100">
      </label>
      <p class="bm-halvany bm-szeles" *ngIf="adat.iktatgato">Az iktatószámot az Iktatgató adja (Bizonyítványok könyv).</p>
      <label>Az eredeti keltezése (ha eltér)
        <input type="date" name="eredeti_keltezes" [(ngModel)]="u.eredeti_keltezes">
      </label>
      <div class="bm-szeles bm-gombok">
        <ion-button type="submit" [disabled]="!kiallithato || fut">
          <ion-icon slot="start" name="ribbon-outline"></ion-icon>Másodlat kiállítása
        </ion-button>
      </div>
    </form>

    <div class="bm-kartya bm-kesz" *ngIf="kesz">
      <b>Elkészült</b> – iktatószám: {{ kesz.iktatoszam }}.
      <a [href]="fajlUrl(kesz.path)" target="_blank" rel="noopener">A másodlat megnyitása (PDF)</a>
      <ul *ngIf="kesz.figyelmeztetes.length"><li *ngFor="let f of kesz.figyelmeztetes">{{ f }}</li></ul>
    </div>
  </ng-container>

  <div class="bm-kartya">
    <h3>Kiállított másodlatok</h3>
    <p class="bm-halvany" *ngIf="!lista.length">Még nem állítottak ki másodlatot.</p>
    <div class="bm-tabla-wrap" *ngIf="lista.length">
      <table class="bm-tabla">
        <thead><tr><th>Kiadás napja</th><th>Tanuló</th><th>Tanév, osztály</th><th>Ok</th><th>Iktatószám</th><th>Kiállító</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let m of lista">
            <td>{{ datum(m.kiadas_napja) }}</td>
            <td>{{ m.tanulo_nev || m.oktazon }}</td>
            <td>{{ m.tanev }}/{{ m.tanev + 1 }} {{ m.osztaly_nev }}</td>
            <td>{{ m.ok_nev }}<span *ngIf="m.ok_reszletek" class="bm-halvany"> – {{ m.ok_reszletek }}</span></td>
            <td>{{ m.iktatoszam }}</td>
            <td>{{ m.kiallito_nev }}</td>
            <td><a *ngIf="m.path" [href]="fajlUrl(m.path)" target="_blank" rel="noopener">PDF</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
